
import { supabase } from '@/integrations/supabase/client';
import { Poll } from '@/types/poll';

/**
 * Updates a linked insight card with the latest poll data using database functions
 * @param poll The poll that was just updated
 */
export const updateLinkedCard = async (poll: Poll) => {
  if (!poll.linked_card_id) return;
  
  try {
    console.log('Updating linked card using database function for poll:', poll.id);
    
    // Call database function to update the card statistics 
    // This will handle both open and closed polls
    const { error } = await supabase.rpc('update_insight_card_stats', {
      input_poll_id: poll.id
    });
    
    if (error) {
      console.error('Error calling update_insight_card_stats function:', error);
      return;
    }
    
    console.log('Successfully updated linked card statistics via database function');
  } catch (error) {
    console.error('Error updating linked card:', error);
  }
};

/**
 * Recalculates statistics for multiple linked polls
 * @param polls Array of polls linked to the same insight card
 */
export const updateLinkedCardFromMultiplePolls = async (polls: Poll[]) => {
  if (polls.length === 0) return;
  
  try {
    // Group polls by their linked card ID
    const cardGroups = polls.reduce((acc, poll) => {
      if (poll.linked_card_id) {
        if (!acc[poll.linked_card_id]) {
          acc[poll.linked_card_id] = [];
        }
        acc[poll.linked_card_id].push(poll);
      }
      return acc;
    }, {} as Record<string, Poll[]>);
    
    // Update each card's statistics
    for (const [cardId, linkedPolls] of Object.entries(cardGroups)) {
      console.log(`Updating card ${cardId} with ${linkedPolls.length} polls`);
      
      // Update each poll's statistics first
      for (const poll of linkedPolls) {
        await supabase.rpc('update_poll_options_counts', {
          poll_id: poll.id
        });
      }
      
      // Then update the card statistics by calling update_insight_card_stats for one of the polls
      // This will update the card with the aggregated data
      if (linkedPolls.length > 0) {
        const { error } = await supabase.rpc('update_insight_card_stats', {
          input_poll_id: linkedPolls[0].id
        });
        
        if (error) {
          console.error(`Error updating card ${cardId} statistics:`, error);
        }
      }
    }
  } catch (error) {
    console.error('Error updating linked cards from multiple polls:', error);
  }
};
